// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606241648/js/" + chunkId + "." + {"44":"7ffd42fb","225":"748a5376","481":"2174d975","486":"8bd138ab","770":"20d767c9"}[chunkId] + ".0.0240896191946407.chunk.js";
};